export const CONTACT_STATUSES = `
query contactStatuses(
  $tenant_id: Int!,
  $filter: ContactStatusFilterInput
) {
  contactStatuses(
    tenant_id: $tenant_id,
    filter: $filter
  ) {
    __typename
    ... on ContactStatus {
      id
      name
      hex_color
      contact_type
      active
      allow_manual
      position
      initial_status
      end_status
      in_process
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
